import {
  signupApi,
  verifyMobileNumberApi,
  sendOtpApi,
  verifyOtpApi,
  verifyEmailApi,
  loginApi,
  adminUsersApi,
  sendEmailOtpApi,
  sendMobileOtpApi
} from "../ENV";
import { fetchApi } from "./FetchAPI";
import { dialogActionsApi } from "../ENV";


export async function verifyMobileNumber(mobileNumber) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  const res = await fetchApi(verifyMobileNumberApi, "GET", {}, headerValue, {"mobile": mobileNumber});
  
  return res;
}

export async function resendOtp(mobileNumber) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  const res = await fetchApi(sendOtpApi, "POST", JSON.stringify({"mobile": mobileNumber}), headerValue, {});
  return res;
}


export async function sendEmailOtp(email) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  const res = await fetchApi(
    sendEmailOtpApi,
    "POST",
    JSON.stringify({ email }),
    headerValue,
    {}
  );
  return res;
}

export async function sendMobileOtp(mobile) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  const res = await fetchApi(
    sendMobileOtpApi,
    "POST",
    JSON.stringify({ mobile }),
    headerValue,
    {}
  );
  return res;
}


export async function verifyOtp(mobileNumber, mobileOtp, email, emailOtp) {
  var payloadJSON = {
    mobile: mobileNumber,
    mobile_otp: mobileOtp,
    email: email,
    email_otp: emailOtp
  };
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
  };
  const res = await fetchApi(
    verifyOtpApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res.data || res;
}

export async function verifyEmail(email) {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json"
  };

  const res = await fetchApi(verifyEmailApi, "GET", {}, headerValue, {"email": email});
  
  return res;
}

export async function login(identifier, otp, isEmail = false) {
  var payloadJSON = isEmail 
    ? { email: identifier, otp: parseInt(otp) }
    : { mobile: identifier, otp: parseInt(otp) };

  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
  };
  const res = await fetchApi(
    loginApi,
    "POST",
    JSON.stringify(payloadJSON),
    headerValue,
    {}
  );
  return res.data || res;
}

export async function register(formData) {
  let formDataObj = {...formData};
  delete formDataObj.otp;
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
  };

  const res = await fetchApi(
    signupApi,
    "POST",
    JSON.stringify(formDataObj),
    headerValue,
    {}
  );
  // Return the data from the response if it exists, otherwise return the response itself
  return res.data || res;
}

export async function fetchUsers(page = 1, limit = 10, search = "") {
  const token = localStorage.getItem("access_token");
  if (!token) {
    throw new Error("No authentication token found");
  }

  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    Authorization: `Bearer ${token}`
  };

  const queryParams = {
    page,
    limit
  };
  
  if (search) {
    queryParams.search = search;
  }

  const res = await fetchApi(
    adminUsersApi,
    "GET",
    {},
    headerValue,
    queryParams
  );

  return res.data || res;
}

// Dialog actions: get and set
export async function getDialogAction(type) {
  const token = localStorage.getItem("access_token");
  if (!token) {
    throw new Error("No authentication token found");
  }

  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    Authorization: `Bearer ${token}`
  };

  const res = await fetchApi(
    dialogActionsApi,
    "GET",
    {},
    headerValue,
    { type }
  );

  return res.data || res;
}

export async function setDialogAction(type, value) {
  const token = localStorage.getItem("access_token");
  if (!token) {
    throw new Error("No authentication token found");
  }

  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    Authorization: `Bearer ${token}`
  };

  const payload = { type, value };

  const res = await fetchApi(
    dialogActionsApi,
    "POST",
    JSON.stringify(payload),
    headerValue,
    {}
  );

  return res.data || res;
}